import Component from '../../components/Component';
import Timeline from '../../components/Timeline';
import Loading from '../../components/Loading';

import query from './query';
import keys from './keys';
import { fillMissingDates } from '../../helpers/fillEmptyDates';
import { withTranslation } from 'react-i18next';

class Summary extends Component {
    constructor() {
        super();
        this.query = query;
    }

    render() {
        if (this.state.loading) {
            return <Loading />;
        }
        const filledAllItems = fillMissingDates(this.state.data ?? []);
        const { t } = this.props;

        return (
            <div>
                <Timeline
                    chartSize="lg"
                    metricType="primary"
                    data={filledAllItems}
                    error={this.state.error}
                    keys={keys(this.state.isDark, t)}
                    parent_id={this.props.parent_id}
                    content_id={this.props.content_id}
                    hasRightAxis
                    hasSecondRightAxis
                    hasLeftSecondAxis
                    leftSecondAxisLabel={t('global.clicks')}
                    leftAxisLabel={t('global.impressions')}
                    rightAxisLabel={t('global.ctr_per')}
                    forceRun={this.forceRun}
                    showGoogleFeeds
                />
            </div>
        );
    }
}

export default withTranslation()(Summary);
